import {
  Controller,
  ControllerValidation,
  CustomWidgetRegistration,
} from '@tempots/beatui'
import '@tempots/beatui/monaco.css'
import { MonacoEditorInput } from '@tempots/beatui/monaco'
import { isEmptyObject, Validation } from '@tempots/std'
import { safeJsonStringify } from '@/utils'

export interface JSONSchemaEditorOptions {
  controller: Controller<unknown>
  setStatus: ((status: ControllerValidation) => void) | undefined
  initialValue?: unknown
}

export function JSONSchemaEditor({
  controller,
  setStatus,
  initialValue,
}: JSONSchemaEditorOptions) {
  let isFirst = true
  return MonacoEditorInput({
    value: controller.signal.map((v) => {
      if (isFirst) {
        isFirst = false
        if (isEmptyObject(v as object)) {
          controller.change(initialValue)
        }
      }
      return safeJsonStringify(v)
    }),
    onChange: (value) => {
      try {
        const unserialized = JSON.parse(value)
        controller.change(unserialized)
      } catch {
        setStatus?.(
          Validation.invalid({
            message: 'Invalid JSON',
            dependencies: {
              fieldName: { message: 'Unable to parse JSON' },
            },
          })
        )
      }
    },
  })
}

interface SchemaDefinition {
  default?: unknown
  example?: unknown
  examples?: unknown[]
}

export const JSONSchemaCustomWidget: CustomWidgetRegistration = {
  factory: ({ controller, setStatus, ctx }) => {
    const definition = ctx.definition as SchemaDefinition | undefined
    const initialValue =
      definition?.default ?? definition?.example ?? definition?.examples?.[0]
    return JSONSchemaEditor({ controller, setStatus, initialValue })
  },
  priority: 100, // Add high priority
  matcher: (ctx) => {
    const matches = ctx.name?.toLowerCase().includes('schema') ?? false
    return matches
  },
}
